'use client';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useClientContext } from '@/contexts/client-context';
import { CreateClientForm } from '@/features/clients/create/create-client-form';
import { useTranslations } from '@/hooks/useTranslations';

export function CreateClientPopup() {
  const { dispatch, state: client } = useClientContext();

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      dispatch({ type: 'OPEN_CREATE_CLIENT_POPUP' });
    } else {
      dispatch({ type: 'CLOSE_CREATE_CLIENT_POPUP' });
    }
  };

  const t = useTranslations('CreateClientPopup');

  return (
    <Sheet
      open={client.isCreateClientPopupOpen}
      onOpenChange={handleOpenChange}
    >
      <SheetContent className="bg-white dark:bg-black">
        <SheetHeader>
          <SheetTitle>{t('addNewClient')}</SheetTitle>
          <SheetDescription>{t('enterDetails')}</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4 p-4">
          <CreateClientForm />
        </div>
      </SheetContent>
    </Sheet>
  );
}
